import PropTypes from 'prop-types';

import Button from '#globalComponents/Button/Button';

export default function CancelAnywayButton({ onClick, disabled = false, label = 'Trotzdem kündigen' }) {
	return (
		<Button variant="danger" size="md" fullWidth onClick={onClick} disabled={disabled}>
			{label}
		</Button>
	);
}

CancelAnywayButton.propTypes = {
	onClick: PropTypes.func.isRequired,
	disabled: PropTypes.bool,
	label: PropTypes.string,
};
